const HorizontalLine = () => {
  return <hr className="horizontalLine" />;
};

export default HorizontalLine;
